<script lang="ts" setup>
// import RevenueUpdates from './cards/RevenueReport.vue'
import ProjectTable from './cards/ProjectTable.vue'
// import RevenueByLocationMap from './cards/RevenueByLocationMap.vue'
import DataSection from './DataSection.vue'
import YearlyBreakup from './cards/YearlyBreakup.vue'
import MonthlyEarnings from './cards/MonthlyEarnings.vue'
// import RegionRevenue from './cards/RegionRevenue.vue'
// import Timeline from './cards/Timeline.vue'
import { onMounted } from 'vue'
import { useHomeStore } from '../../../stores/home'

const homeStore: any = useHomeStore()

onMounted(async () => {
  await homeStore.getHomeData()
})
</script>

<template>
  <h1 class="page-title font-bold">Dashboard</h1>
  <section v-if="homeStore.data.loaded" class="flex flex-col gap-4">
    <div class="flex flex-col sm:flex-row gap-4">
      <!--      <RevenueUpdates class="w-full sm:w-[70%]" />-->
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4 w-full flex-1">
        <YearlyBreakup class="w-full h-full flex-1" />
        <MonthlyEarnings class="w-full h-full flex-1" />
      </div>
    </div>
    <DataSection />
    <!--    <div class="flex flex-col md:flex-row gap-4">-->
    <!--      <RevenueByLocationMap class="w-full md:w-4/6" />-->
    <!--      <RegionRevenue class="w-full md:w-2/6" />-->
    <!--    </div>-->
    <div class="flex flex-col md:flex-row gap-4">
      <ProjectTable class="w-full" />
      <!--      <Timeline class="w-full" />-->
    </div>
  </section>
</template>
